import { render, staticRenderFns } from "./MDretouches.vue?vue&type=template&id=0828d078"
import script from "./MDretouches.vue?vue&type=script&lang=js"
export * from "./MDretouches.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports